import * as React from 'react'
import 'react-day-picker/dist/style.css'
import styled, { keyframes } from 'styled-components'
import de from 'date-fns/locale/de'
import en from 'date-fns/locale/en-GB'
import enUs from 'date-fns/locale/en-US'
import enCa from 'date-fns/locale/en-CA'
import fr from 'date-fns/locale/fr'
import frCa from 'date-fns/locale/fr-CA'
import es from 'date-fns/locale/es'
import ka from 'date-fns/locale/ka'
import { DayPicker, DayProps } from 'react-day-picker'
import { moment } from '../../services/utils/moment.service'

export function getDayPickerDateLocale () {
  const localeByKey = { de, 'en-CA': enCa, 'en-US': enUs, en, es, 'fr-CA': frCa, 'fr-US': frCa, fr, ka }
  return (localeByKey as any)[window.locale] || en
}

const bounceDate = keyframes`
  25% { transform: scale(0.5); }
  75% { transform: scale(1.05); }
  100% { transform: scale(1); }
`

export const StyledDayPickerNoAddtionalProps = styled(DayPicker)<{ noBackground?: boolean }>`
  ${ props => !props.noBackground && `background: ${ props.theme.colors.clr_0_lightest };` }
  border-radius: 0.125rem;
  
  table {
    border: none !important;
    table-layout: fixed !important; /* Fix calendar overflows parent container */
    width: unset;
  }

  th {
    padding: 0.2em !important;
  }

  td {
    padding: 0 !important;
    border: none !important;
  }

  .rdp-caption_label {
    text-align: center;
    text-transform: uppercase;
    font-size: 0.875rem;
    font-weight: 700;
  }

  h2 {
    color: ${ props => props.theme.colors.clr_0 };
  }

  .rdp-months {
    justify-content: center;
    margin: auto;
  }

  .rdp-selected {
    animation: ${bounceDate} .5s ease-in-out forwards;
    font-size: unset;
  }

  &.rdp-root {
    --rdp-cell-size: 33px;
    --rdp-accent-color: ${ props => props.theme.colors.clr_1 };
    --rdp-background-color: ${ props => props.theme.colors.clr_1_light };
    --rdp-font-family: 1rem;
    --rdp-day_button-width: 2.5rem;
    --rdp-day_button-height: 2.5rem;
    --rdp-day-width: 2.5em;
    --rdp-day-height: 2.5em;
    /* Switch to dark colors for dark themes */
    --rdp-accent-color-dark: ${ props => props.theme.colors.clr_1 };
   --rdp-background-color-dark: ${ props => props.theme.colors.clr_1_light };
  }
`

/**
 * Based on https://github.com/gpbl/react-day-picker/blob/main/src/components/Day.tsx
 * with the addition of an ID property for E2E testing purposes.
 */
export function Day (props: DayProps) {
  const { day, modifiers, ...tdProps } = props // eslint-disable-line @typescript-eslint/no-unused-vars
  return <td { ...tdProps } data-e2e-date={ moment(day.date).format('YYYY-MM-DD') } />
}

export const StyledDayPicker = function (props: any) {
  return <StyledDayPickerNoAddtionalProps { ...props } components={{ Day }}/>
} as typeof StyledDayPickerNoAddtionalProps

